// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /object/get-batch.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeObjectGetBatchBody,
  typeObjectGetBatchOutput200,
} from "../../sdk/object/postObjectGetBatch";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildObjectGetBatchQueryKey(
  payload: typeObjectGetBatchBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`mediaIds:${JSON.stringify(payload.mediaIds)}`);
  return ["post:object:objectGetBatch", "svc:media-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeObjectGetBatchOutput200,
    unknown,
    typeObjectGetBatchOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useObjectGetBatch(
  payload: typeObjectGetBatchBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildObjectGetBatchQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postObjectGetBatch(payload),
    ...resolvedOptions,
  });
}
